import template from './addAlertMessage.html';
import controller from './addAlertMessage.controller';

let addAlertMessageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default addAlertMessageComponent;



// WEBPACK FOOTER //
// ./app/components/addAlertMessage/addAlertMessage.component.js